import { Button } from "@material-ui/core";
import IncidentLinkButton from "../Components/IncidentLinkButton";
import { withStyles } from "@material-ui/core/styles";
import { formatNameFromPersonObj, personAlertColor } from "./utils";
import moment from "moment";

const StyledTableLinkButton = withStyles(() => ({
  root: {
    backgroundColor: "transparent",
    border: "none",
    cursor: "pointer",
    textDecoration: "underline",
    display: "inline",
    margin: "0",
    padding: "0",
    textTransform: "none",
  },
}))(Button);

// Type	Date & Time	Incident #	Officers	Role	Address
//The idNames need to match the row names in parse funtion
export const personIncidentHistoryHeaders = [
  { title: "Type", idName: "type", show: true },
  { title: "Date & Time", idName: "callTime", show: true },
  { title: "Incident\xa0#", idName: "incidentNumber", show: true },
  { title: "Officers", idName: "badges", show: true },
  { title: "Role", idName: "role", show: true },
  { title: "Address", idName: "location", show: true },
];

// uses an array of personIncidentSpecifics
export function parsePersonIncidentHistory(arr, clickHandler, userRoles) {
  let tempRows = [];
  if (arr.length > 0) {
    arr.map((pis) => {
      const { incident, id: pisId } = pis || {};
      const type = incident?.classification?.name;
      const callTime = incident?.callTime
        ? moment
            .utc(incident?.callTime, "YYYY-MM-DD HH:mm:ss UTC")
            .local()
            .format("MM/DD/YYYY HH:mm")
        : "";
      const incidentNumber = (
        <IncidentLinkButton
          handleIncidentOpening={clickHandler}
          incident={incident}
          userRoles={userRoles}
        />
      );
      const badges = incident?.officerIncidentSpecifics
        .map(ois => ois?.officer?.deptAttribute?.badge)
        ?.join(", ");
      const role = pis?.incidentInvolvement?.name;
      const location = incident?.address?.name;
      tempRows.push(
        createIncidentData(
          type,
          callTime,
          incidentNumber,
          badges,
          role,
          location,
          pisId,
        ),
      );
      return null;
    });
    return tempRows;
  } else {
    return tempRows;
  }
}

function createIncidentData(
  type,
  callTime,
  incidentNumber,
  badges,
  role,
  location,
  pisId,
) {
  return { type, callTime, incidentNumber, badges, role, location, pisId };
}

// ********************************************************************************************** //
export const personTicketHistoryHeaders = [
  { title: "Incident\u00a0#", idName: "incidentNumber", show: true },
  { title: "Ticket\u00a0#", idName: "ticketNumber", show: true },
  { title: "Officer", idName: "officer", show: true },
  { title: "Date/Time", idName: "dateTime", show: true },
  { title: "Location", idName: "location", show: true },
  { title: "Violation", idName: "violation", show: true },
  { title: "Type", idName: "type", show: true },
];

export function parsePersonTicketHistory(
  tickets,
  handleIncidentOpening,
  userRoles,
  handleTicketOpening,
) {
  return (tickets || []).map(ticket => {
    const incident = ticket?.incident;
    const incidentNumber = incident?.id ? (
      <IncidentLinkButton
        handleIncidentOpening={handleIncidentOpening}
        incident={{
          ...incident,
          incidentNumber: incident.incidentNumber || incident.id,
        }}
        userRoles={userRoles}
      />
    ) : null;
    const ticketNumber = ticket?.id ? (
      <StyledTableLinkButton
        data-cy={"tablecell-ticket-number-link-" + ticket.id}
        onClick={() => handleTicketOpening(ticket.id, true)}
      >
        {ticket.ticketNumber || "No number"}
      </StyledTableLinkButton>
    ) : null;
    const badge = ticket?.officer?.deptAttribute?.badge;
    const officerName = ticket?.officer
      ? formatNameFromPersonObj(ticket.officer)
      : "";
    const officer = [badge, officerName].filter(Boolean).join(": ");
    const dateTime = ticket?.issuedAt
      ? moment
          .utc(ticket.issuedAt, "YYYY-MM-DD HH:mm:ss UTC")
          .local()
          .format("MM/DD/YYYY HH:mm")
      : "";
    const location =
      ticket?.ticketLocation?.name || incident?.address?.name || "";
    const code = ticket?.ticketViolationPrototype?.code;
    const name = ticket?.ticketViolationPrototype?.name;
    const violation = [code, name].filter(Boolean).join(" - ");
    const type = ticket?.ticketViolationPrototype?.ticketEntry?.name || "";

    return {
      id: ticket?.id,
      incidentNumber,
      ticketNumber,
      officer,
      dateTime,
      location,
      violation,
      type,
    };
  });
}

// ********************************************************************************************** //
export const personDrugHistoryHeaders = [
  { title: "Type", idName: "type", show: true },
  { title: "Date & Time", idName: "callTime", show: true },
  { title: "Incident\xa0#", idName: "incidentNumber", show: true },
  { title: "Officers", idName: "badges", show: true },
  { title: "Role", idName: "role", show: true },
  { title: "Drugs", idName: "drugs", show: true },
];
// uses an array of personIncidentSpecifics
export function parsePersonDrugHistory(arr, clickHandler, userRoles) {
  let tempRows = [];
  if (arr.length > 0) {
    arr.map((pis) => {
      const { incident, id: pisId } = pis || {};
      const type = incident?.classification?.name;
      const callTime = incident?.callTime
        ? moment
            .utc(incident?.callTime, "YYYY-MM-DD HH:mm:ss UTC")
            .local()
            .format("MM/DD/YYYY HH:mm")
        : "";
      const incidentNumber = (
        <IncidentLinkButton
          handleIncidentOpening={clickHandler}
          incident={incident}
          userRoles={userRoles}
        />
      );
      const badges = incident?.officerIncidentSpecifics
        .map(ois => ois?.officer?.deptAttribute?.badge)
        ?.join(", ");
      const role = pis?.incidentInvolvement?.name;
      const drugs = pis?.drugTypes.map(dt => dt.name).join(", ");

      tempRows.push(
        createDrugData(
          type,
          callTime,
          incidentNumber,
          badges,
          role,
          drugs,
          pisId,
        ),
      );
      return null;
    });
    return tempRows;
  } else {
    return tempRows;
  }
}

function createDrugData(
  type,
  callTime,
  incidentNumber,
  badges,
  role,
  drugs,
  pisId,
) {
  return { type, callTime, incidentNumber, badges, role, drugs, pisId };
}
// ********************************************************************************************** //
export const personVehicleHistoryHeaders = [
  { title: "Make", idName: "make", show: true },
  { title: "Model", idName: "model", show: true },
  { title: "Year", idName: "year", show: true },
  { title: "Plate", idName: "plate", show: true },
  { title: "State", idName: "state", show: true },
  { title: "VIN", idName: "vin", show: true },
];
//assume an array of vehicles

export function parsePersonVehicleHistory(arr) {
  let tempRows = [];
  if (arr.length > 0) {
    arr.map((vehicle) => {
      const vehicleId = vehicle?.id;
      const make = vehicle?.vehicleMake?.name;
      const model = vehicle?.vehicleModel?.name;
      const year = vehicle?.year;
      const plate = vehicle?.vehiclePlate?.name;
      const state = vehicle?.vehicleState?.name;
      const vin = vehicle?.vehicleVin?.name;
      tempRows.push(
        createVehicleData(make, model, year, plate, state, vin, vehicleId),
      );
      return null;
    });
    return tempRows;
  } else {
    return tempRows;
  }
}

function createVehicleData(make, model, year, plate, state, vin, vehicleId) {
  return { make, model, year, plate, state, vin, vehicleId };
}

// ********************************************************************************************** //
export const personNameHistoryHeaders = [
  { title: "Name", idName: "name", show: true },
  { title: "Last Updated", idName: "updatedAt", show: true },
];

export function parsePersonNameHistory(arr) {
  let tempRows = [];
  if (arr.length > 0) {
    arr.map((historicalName) => {
      const nameId = historicalName?.id;
      const name = historicalName?.value;
      const updatedAt = historicalName?.lastUpdated
        ? moment
            .utc(historicalName?.lastUpdated, "YYYY-MM-DD HH:mm:ss UTC")
            .local()
            .format("MM/DD/YYYY HH:mm")
        : "";
      tempRows.push(createNameData(nameId, name, updatedAt));
      return null;
    });
    return tempRows;
  } else {
    return tempRows;
  }
}

function createNameData(nameId, name, updatedAt) {
  return { nameId, name, updatedAt };
}

// ********************************************************************************************** //
export const personPhoneHistoryHeaders = [
  { title: "Phone Number", idName: "phone", show: true },
  { title: "Last Updated", idName: "updatedAt", show: true },
];

export function parsePersonPhoneHistory(arr) {
  let tempRows = [];
  if (arr.length > 0) {
    arr.map((historicalPhone) => {
      const phoneId = historicalPhone?.id;
      const phone = historicalPhone?.value;
      const updatedAt = historicalPhone?.lastUpdated
        ? moment
            .utc(historicalPhone?.lastUpdated, "YYYY-MM-DD HH:mm:ss UTC")
            .local()
            .format("MM/DD/YYYY HH:mm")
        : "";
      tempRows.push(createPhoneData(phoneId, phone, updatedAt));
      return null;
    });
    return tempRows;
  } else {
    return tempRows;
  }
}

function createPhoneData(phoneId, phone, updatedAt) {
  return { phoneId, phone, updatedAt };
}

// ********************************************************************************************** //
export const personAddressHistoryHeaders = [
  { title: "Address", idName: "addressName", show: true },
  // { title: 'Last Updated', idName: 'updatedAt', show: true },
];

export function parsePersonAddressHistory(arr) {
  let tempRows = [];
  if (arr.length > 0) {
    arr.map((address) => {
      const addressId = address?.id;
      const addressName = address?.name;
      // const updatedAt = address?.updatedAt
      tempRows.push(createAddressData(addressId, addressName));
      return null;
    });
    return tempRows;
  } else {
    return tempRows;
  }
}

function createAddressData(addressId, addressName) {
  return { addressId, addressName };
}
// ********************************************************************************************** //

export const aliasHistoryHeaders = () => {
  return [
    { title: "Description", idName: "description", show: true },
    { title: "Name", idName: "name", show: true },
    { title: "Last Updated", idName: "updatedAt", show: true },
  ];
};

export function parsePersonAliasHistory(arr, handlePersonOpening) {
  let tempRows = [];
  if (arr.length > 0) {
    arr.map((alias) => {
      const { description, id, updatedAt } = alias || "";
      const { target } = alias || {};
      const targetName = (
        <StyledTableLinkButton
          style={{ color: personAlertColor(target) }}
          data-cy={"tablecell-person-name-link-" + target?.id}
          onClick={() => {
            handlePersonOpening(target?.id, true);
          }}
        >
          {formatNameFromPersonObj(target)}
        </StyledTableLinkButton>
      );
      const updatedAtString =
        moment
          .utc(updatedAt, "YYYY-MM-DD HH:mm:ss UTC")
          .local()
          .format("MM/DD/YYYY HH:mm") || "";

      tempRows.push(
        createAliasHistoryData(id, description, targetName, updatedAtString),
      );
      return null;
    });
    return tempRows;
  } else {
    return tempRows;
  }
}

function createAliasHistoryData(id, description, name, updatedAt) {
  return {
    id,
    description,
    name,
    updatedAt,
  };
}
// ********************************************************************************************** //
export const knownAssociatesHeaders = incidentId => {
  return [
    { title: "Name", idName: "associateName", show: true },
    { title: "Person Type", idName: "associatePersonType", show: true },
    { title: "Incident #", idName: "associateIncidentNumber", show: true },
    { title: "DOB", idName: "associateDob", show: true },
    { title: "Date of Association", idName: "associationDate", show: true },
    { title: "Add", idName: "addButton", show: incidentId ? true : false },
  ];
};

export function parseKnownAssociates(
  arr,
  handleIncidentOpening,
  handlePersonOpening,
  userRoles,
  handleAddPerson,
  incidentId,
) {
  let tempRows = [];
  if (arr.length > 0) {
    arr.map((pis) => {
      const { person, incident, incidentInvolvement } = pis || {};
      const id = pis?.id;
      const associateName = (
        <StyledTableLinkButton
          style={{ color: personAlertColor(person) }}
          data-cy={"tablecell-person-name-link-" + person?.id}
          onClick={() => {
            handlePersonOpening(person?.id, true);
          }}
        >
          {formatNameFromPersonObj(person)}
        </StyledTableLinkButton>
      );
      const associatePersonType = incidentInvolvement?.name;
      const associateIncidentNumber = (
        <IncidentLinkButton
          handleIncidentOpening={handleIncidentOpening}
          incident={incident}
          userRoles={userRoles}
        />
      );
      const associateDob = person?.personalAttribute?.dob
        ? moment
            .utc(person?.personalAttribute?.dob, "YYYY-MM-DD HH:mm:ss UTC")
            .local()
            .format("MM/DD/YYYY")
        : "";
      const associationDate = incident?.callTime
        ? moment
            .utc(incident?.callTime, "YYYY-MM-DD HH:mm:ss UTC")
            .local()
            .format("MM/DD/YYYY")
        : "";
      const addButton = incidentId ? (
        <button
          style={{}}
          data-cy={"tablecell-add-assoc-to-incident" + person?.id}
          onClick={() => handleAddPerson(person, incidentId)}
        >
          Add
        </button>
      ) : null;
      tempRows.push(
        createKnownAssociatesData(
          id,
          associateName,
          associatePersonType,
          associateIncidentNumber,
          associateDob,
          associationDate,
          addButton,
        ),
      );
      return null;
    });
    return tempRows;
  } else {
    return tempRows;
  }
}

function createKnownAssociatesData(
  id,
  associateName,
  associatePersonType,
  associateIncidentNumber,
  associateDob,
  associationDate,
  addButton,
) {
  return {
    id,
    associateName,
    associatePersonType,
    associateIncidentNumber,
    associateDob,
    associationDate,
    addButton,
  };
}
